<template>
  <div class="job-lang-skill job-lang-skill--header">
    <div class="job-lang-skill__label">
      <component :is="svgComponentName" class="job-requirement__icon svg-fill" />
      <h5>{{ headerLabel }}</h5>
    </div>
    <div class="job-lang-skill__level">
      <span class="job-lang-skill__level-basic">{{ $t('jobDetail.languageBasic') }}</span>
      <span class="flex-1" />
      <span class="job-lang-skill__level-excellent">{{ $t('jobDetail.languageExcellent') }}</span>
    </div>
  </div>
</template>

<script>
import SvgSpokenSkill from '../../../assets/svg/spokenSkill.svg?inline'
import SvgWrittenSkill from '../../../assets/svg/writtenSkill.svg?inline'

export default {
  components: {
    'svg-spoken': SvgSpokenSkill,
    'svg-written': SvgWrittenSkill,
  },
  computed: {
    headerLabel() {
      return this.$t(`jobDetail['${this.type}Skills']`)
    },
    svgComponentName() {
      return `svg-${this.type}`
    },
  },
  props: {
    type: {
      default: 'stroke',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.job-lang-skill--header {
  @apply mb-2;

  & h5 {
    @apply font-medium;
  }
}

@screen mobile {
  .job-lang-skill__level-excellent {
    @apply mr-1;
  }
}

@screen desktop {
  .job-lang-skill--header h5 {
    @apply text-17/4;
  }
}
</style>
